import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java;
const RUTA_PESOS = "weights"
function processPeso(peso) {
    let data_peso = {
        id: peso.weightId,
        fecha: peso.weightDate,
        pesoanterior: 0,
        pesonuevo: peso.weight,
        animal: peso.animalId,
        created:peso.creationDate,
        expand: {
            animal: {
                id: peso.animalId,
                caravana: peso.animalTagNumber
            }
        }
    }
    return data_peso
}
export function processPesos(data, cabid = null) {
    let data_pesos = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        if (cabid) {
            if (fila.establishmentId == cabid) {
                data_pesos.push(processPeso(fila))
            }
        }
        else {
            data_pesos.push(processPeso(fila))
        }

    }
    return data_pesos
}
export async function getAllAnimal(animalId,cabid = null) {
 let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_PESOS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    if (animalId) {
        url.searchParams.append('animalId', animalId);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(url.toString(), options)
    let data_all = await jsonOrThrow(res_all, "pesajes.getAllAnimal")
    data_all = data_all.filter(a=>a.animalId==animalId)
    let procesada = processPesos(data_all,cabid)
    return procesada   
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAll(cabid = null) {
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_PESOS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }

    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)
        let data_all = await jsonOrThrow(res_all, "pesajes.getAll")
        return processPesos(data_all,cabid)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.weights(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
function postData(data) {
    let data_peso = {
        animalId: data.animal,
        weightDate: data.fecha.split(" ")[0],
        weight: data.pesonuevo,
        notes: ""
    }
    return data_peso
}
export async function savePeso(data) {
    let ruta = `${RUTA_JAVA}${RUTA_PESOS}`

    let data_peso = postData(data)

    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_peso), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let data_save = await res_save.json()
    return data_save

}
export async function editPeso(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_PESOS}/${id}`

    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function eliminarPeso(id) {
    let ruta = `${RUTA_JAVA}${RUTA_PESOS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}